/* product-card-carousel.js — translate3d + spring animation */
(function () {
  'use strict';

  var SWIPE_THRESHOLD_RATIO = 0.2;
  var ANIM_DURATION = 400;
  var INIT_DELAY = 150;
  var initializedCards = new WeakSet();

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initCarousels, INIT_DELAY);
    observeNewCards();
  });
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initCarousels, INIT_DELAY);
  });

  function observeNewCards() {
    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('product-card') || node.querySelector && node.querySelector('.product-card')) {
            if (!scheduled) {
              scheduled = true;
              setTimeout(function () { scheduled = false; initCarousels(); }, INIT_DELAY);
            }
            return;
          }
        }
      }
    });
    // Acotado a <main> (no a todo el body) para no reaccionar a mutaciones de apps
    // en header/footer/overlays. Las tarjetas con carrusel viven en el contenido principal.
    var root = document.querySelector('main') || document.body;
    observer.observe(root, { childList: true, subtree: true });
  }

  function initCarousels() {
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function (card) {
      if (initializedCards.has(card)) return;
      var track = card.querySelector('.product-card__carousel-track');
      var slides = card.querySelectorAll('.product-card__slide');
      if (!track || slides.length === 0) return;
      initializedCards.add(card);
      initCarousel(card);
    });
  }

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function initCarousel(card) {
    var track = card.querySelector('.product-card__carousel-track');
    var slides = card.querySelectorAll('.product-card__slide');
    var dotsContainer = card.querySelector('.dots-container');
    var dots = dotsContainer ? dotsContainer.querySelectorAll('.dot') : [];
    var prevBtn = card.querySelector('.product-card__carousel-arrow--prev');
    var nextBtn = card.querySelector('.product-card__carousel-arrow--next');
    var wrapper = card.querySelector('.product-card__carousel-wrapper');

    if (slides.length < 2) {
      if (dotsContainer) dotsContainer.style.display = 'none';
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    var currentIndex = 0;
    var currentTranslate = 0;
    var prevTranslate = 0;
    var isDragging = false;
    var startX = 0;
    var startY = 0;
    var animId = null;
    var slideWidth = 0;
    var suppressClick = false;
    var lastTouchTime = 0;

    function loadSlide(index) {
      var slide = slides[index];
      var template = slide && slide.querySelector('template[data-card-media]');
      if (template) {
        var fragment = template.content.cloneNode(true);
        fragment.querySelectorAll('img[data-src]').forEach(function (image) {
          // Some browsers preload src URLs even inside template content.
          if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
          image.setAttribute('src', image.dataset.src);
          image.removeAttribute('data-src');
          image.removeAttribute('data-srcset');
        });
        template.replaceWith(fragment);
      }
    }

    function prepareDrag() {
      // Read layout once per gesture, before writes; never once per touchmove.
      slideWidth = getSlideWidth();
      suppressClick = false;
    }

    function getSlideWidth() {
      return wrapper ? wrapper.clientWidth : slides[0].offsetWidth;
    }

    function setPosition(x) {
      track.style.transform = 'translate3d(' + Math.round(x) + 'px, 0px, 0px)';
    }

    function springAnimate(from, to, onDone) {
      if (animId) cancelAnimationFrame(animId);
      track.style.willChange = 'transform';
      var startTime = performance.now();
      function tick(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / ANIM_DURATION, 1);
        var val = from + (to - from) * easeOut(progress);
        currentTranslate = val;
        setPosition(val);
        if (progress < 1) {
          animId = requestAnimationFrame(tick);
        } else {
          currentTranslate = to;
          prevTranslate = to;
          setPosition(to);
          track.style.willChange = 'auto';
          if (onDone) onDone();
        }
      }
      animId = requestAnimationFrame(tick);
    }

    function goToSlide(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      slideWidth = getSlideWidth();
      loadSlide(index);
      currentIndex = index;
      var target = -(index * slideWidth);
      springAnimate(currentTranslate, target);
      updateDots();
      updateButtons();
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        var fill = dot.querySelector('.dot-fill');
        if (i === currentIndex) {
          dot.classList.add('active');
          if (!fill) {
            fill = document.createElement('div');
            fill.className = 'dot-fill';
            dot.appendChild(fill);
          }
        } else {
          dot.classList.remove('active');
          if (fill) fill.remove();
        }
      });
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;
    }

    // Arrow buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        goToSlide(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        goToSlide(currentIndex + 1);
      });
    }

    // Touch — follow finger
    track.addEventListener('touchstart', function (e) {
      lastTouchTime = performance.now();
      prepareDrag();
      isDragging = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      track.style.willChange = 'transform';
      if (animId) cancelAnimationFrame(animId);
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      var diff = e.touches[0].clientX - startX;
      if (!suppressClick && Math.abs(e.touches[0].clientY - startY) > Math.abs(diff)) return;
      currentTranslate = prevTranslate + diff;
      // Clamp to prevent overscroll
      if (Math.abs(diff) > 5) {
        suppressClick = true;
        loadSlide(currentIndex + (diff < 0 ? 1 : -1));
      }
      var minX = -((slides.length - 1) * slideWidth);
      currentTranslate = Math.max(minX, Math.min(0, currentTranslate));
      setPosition(currentTranslate);
    }, { passive: true });

    track.addEventListener('touchend', function () {
      lastTouchTime = performance.now();
      isDragging = false;
      var movedBy = currentTranslate - prevTranslate;
      var threshold = slideWidth * SWIPE_THRESHOLD_RATIO;
      if (Math.abs(movedBy) > threshold) {
        goToSlide(movedBy < 0 ? currentIndex + 1 : currentIndex - 1);
      } else {
        goToSlide(currentIndex); // snap back
      }
    });
    track.addEventListener('touchcancel', function () {
      lastTouchTime = performance.now();
      isDragging = false;
      goToSlide(currentIndex);
    });

    // Mouse drag (desktop)
    var mouseStartX = null;
    var isMouseDragging = false;

    track.addEventListener('mousedown', function (e) {
      if (lastTouchTime && performance.now() - lastTouchTime < 700) return;
      if (e.button !== 0) return;
      prepareDrag();
      mouseStartX = e.clientX;
      isMouseDragging = false;
      track.style.willChange = 'transform';
      if (animId) cancelAnimationFrame(animId);
      track.style.cursor = 'grabbing';
    });
    track.addEventListener('mousemove', function (e) {
      if (lastTouchTime && performance.now() - lastTouchTime < 700) return;
      if (mouseStartX === null) return;
      var diff = e.clientX - mouseStartX;
      if (Math.abs(diff) > 5) isMouseDragging = true;
      if (isMouseDragging) {
        suppressClick = true;
        loadSlide(currentIndex + (diff < 0 ? 1 : -1));
        currentTranslate = prevTranslate + diff;
        var minX = -((slides.length - 1) * slideWidth);
        currentTranslate = Math.max(minX, Math.min(0, currentTranslate));
        setPosition(currentTranslate);
      }
    });
    track.addEventListener('mouseup', function (e) {
      if (lastTouchTime && performance.now() - lastTouchTime < 700) return;
      if (mouseStartX === null) return;
      if (isMouseDragging) {
        var movedBy = currentTranslate - prevTranslate;
        var threshold = slideWidth * SWIPE_THRESHOLD_RATIO;
        if (Math.abs(movedBy) > threshold) {
          goToSlide(movedBy < 0 ? currentIndex + 1 : currentIndex - 1);
        } else {
          goToSlide(currentIndex);
        }
      }
      mouseStartX = null;
      isMouseDragging = false;
      track.style.cursor = 'grab';
    });
    track.addEventListener('mouseleave', function () {
      if (mouseStartX !== null && isMouseDragging) {
        goToSlide(currentIndex);
      }
      mouseStartX = null;
      isMouseDragging = false;
      track.style.cursor = 'grab';
    });

    // Prevent link clicks after drag
    track.addEventListener('click', function (e) {
      if (e.detail === 0) { suppressClick = false; return; }
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      }
    }, true);

    // Init (sin will-change/backface — se aplican solo durante interaccion)
    // This viewport moves by transform, never by native scrolling. In Firefox,
    // focusing an arrow can otherwise scroll overflow:hidden and crop the photo.
    if (wrapper) wrapper.style.overflow = 'clip';
    track.style.display = 'flex';
    track.style.cursor = 'grab';
    track.style.touchAction = 'pan-y';
    slides.forEach(function (s) {
      s.style.flex = '0 0 100%';
      s.style.minWidth = '100%';
      s.style.userSelect = 'none';
    });

    setPosition(0);
    updateDots();
    updateButtons();

    // Keep the selected photo aligned after rotation, resizing or revealing a tab.
    if (window.ResizeObserver && wrapper) {
      var resizeObserver = new ResizeObserver(function (entries) {
        var width = entries[0].contentRect.width;
        if (!width || width === slideWidth) return;
        slideWidth = width;
        if (animId) cancelAnimationFrame(animId);
        currentTranslate = prevTranslate = -(currentIndex * width);
        setPosition(currentTranslate);
        track.style.willChange = 'auto';
      });
      resizeObserver.observe(wrapper);
    }
  }
  // Swatch click → update variant name text
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.product-card .color-swatch, .product-card .block-swatch, .product-card .thumbnail-swatch');
    if (!swatch) return;
    var card = swatch.closest('.product-card');
    if (!card) return;
    var nameEl = card.querySelector('.product-card__variant-name');
    if (!nameEl) return;
    var label = swatch.getAttribute('data-tooltip') || swatch.getAttribute('aria-label') || swatch.querySelector('.sr-only')?.textContent;
    if (label) nameEl.textContent = label.trim();
  });

  // Desktop mosaic: highlight variant image on variant change
  // NO MutationObserver — only listens to theme events
  document.addEventListener('DOMContentLoaded', function() {
    var mosaic = document.querySelector('[data-mosaic-gallery]');
    if (!mosaic) return;

    var translations = {pt:'Variante selecionada',es:'Variante seleccionada',en:'Selected variant',fr:'Variante selectionnee',de:'Ausgewaehlte Variante',it:'Variante selezionata'};
    var lang = (document.documentElement.lang || 'es').substring(0,2);
    var labelText = translations[lang] || translations.en;
    mosaic.querySelectorAll('.gallery-mosaic__label').forEach(function(l){ l.textContent = labelText; });

    function highlight(mediaId) {
      if (!mediaId) return;
      var id = String(mediaId);
      var found = false;
      mosaic.querySelectorAll('.gallery-mosaic__item').forEach(function(item) {
        if (String(item.getAttribute('data-media-id')) === id) {
          item.classList.add('is-variant-selected');
          found = true;
        } else {
          item.classList.remove('is-variant-selected');
        }
      });
      if (found) {
        var el = mosaic.querySelector('.is-variant-selected');
        if (el) {
          if (mosaic.showMedia) mosaic.showMedia(mediaId);
          else if (window.matchMedia('(min-width: 1000px)').matches) el.scrollIntoView({behavior:'smooth',block:'nearest'});
        }
      }
    }

    // Listen to Prestige theme variant:change event (bubbles to document)
    // LPM: el slider móvil se mueve desde su propio script (product-gallery*.liquid) vía goToSlide,
    // que mantiene currentIndex/prevTranslate/dots en sync. Escribir track.style.transform desde
    // aquí desincronizaba el estado y el siguiente swipe "saltaba" hacia atrás.
    document.addEventListener('variant:change', function(e) {
      try {
        var media = e.detail.variant.featured_media;
        if (!media) return;
        // Desktop: highlight mosaic
        highlight(media.id);
      } catch(err) {}
    });
  });
})();
